import "./RequestAQuote.module.css";
import Header from "@/reusable_sections/Header";
import QuotationHero from "./sections/QuotationHero";
import ContactForm from "./sections/ContactForm";
import QuoteNextSteps from "./sections/QuoteNextSteps";
import Footer from "@/reusable_sections/Footer";
export default function RequestAQuotePage() {
  return <div>
      <Header />
      <QuotationHero />
      <ContactForm />
      <QuoteNextSteps />
      <Footer />
    </div>;
}